import { toISODate } from "../Persons/HelperFunctions";
import { StatusBody } from "../utils/StatusBody";
import classes from "./EhsConfigurations.module.scss";
import { EHS_LANGUAGES } from "./NavHelpers";

const DateTimeCreatedBody = (data: { dateTimeCreated: string }) => (
  <span>{toISODate(new Date(data.dateTimeCreated))}</span>
);

const UploadedByBody = (data: {
  temp: { createdBy: { userDemographic: { displayName } } };
}) => (
  <span className={classes.truncate}>
    {data?.temp?.createdBy?.userDemographic?.displayName}
  </span>
);

const DescriptionBody = (data: { description: string }) => (
  <span className={classes.truncate}>{data.description}</span>
);

const LanguageBody = (data: { configurationType: { name: string } }) => {
  const lang = EHS_LANGUAGES.find(
    (language) => language.name === data.configurationType.name
  );
  return <span>{lang?.displayName}</span>;
};

const commonColumns = [
  {
    field: "version",
    header: "ehs_config_version_number",
    sortable: true,
  },
  {
    field: "description",
    header: "universal_Description",
    body: DescriptionBody,
  },
  {
    field: "temp.createdBy.userDemographic.displayName",
    header: "ehs_config_uploaded_by",
    body: UploadedByBody,
  },
  {
    field: "dateTimeCreated",
    header: "ehs_config_uploaded_date",
    body: DateTimeCreatedBody,
  },
  {
    field: "IsActive",
    header: "universal_Status",
    body: StatusBody,
    sortable: true,
  },
];

const langugeColumns = [
  {
    field: "version",
    header: "ehs_config_version_number",
    sortable: true,
  },
  {
    field: "language",
    header: "universal_Language",
    filterable: true,
    filterField: "language",
    options: EHS_LANGUAGES.map((value) => ({
      id: value.name,
      label: value.displayName,
    })),
    body: LanguageBody,
  },
  {
    field: "description",
    header: "universal_Description",
    body: DescriptionBody,
  },
  {
    field: "temp.createdBy.userDemographic.displayName",
    header: "ehs_config_uploaded_by",
    body: UploadedByBody,
  },
  {
    field: "dateTimeCreated",
    header: "ehs_config_uploaded_date",
    body: DateTimeCreatedBody,
  },
  {
    field: "IsActive",
    header: "universal_Status",
    body: StatusBody,
    sortable: true,
  },
];

const Columns = {
  languages: langugeColumns,
  common: commonColumns,
};

export { Columns };
